import { createReducer, on } from '@ngrx/store';
import { PnpBudget } from '../../models/pnp-budget.model';

import {
  fetchPnpBudgets,
  fetchPnpBudgetsSuccess,
  fetchPnpBudgetsFailure,
  fetchPnpBudgetsForOrder,
  fetchPnpBudgetsForOrderSuccess,
  fetchPnpBudgetsForOrderFailure, resetPnpBudgetsForOrder,
  fetchBudgetAvailable,
  fetchBudgetAvailableSuccess,
  fetchBudgetAvailableFailure,
  resetBudgetAvailable,
  setPnpBudgetsForOrder,
} from '../actions/pnp-budget.actions';

export interface IPnpBudgetState {
  userBudgets: PnpBudget[];
  fetchingUserBudgets: boolean;
  fetchingForOrderId: number | null;
  budgetsByOrderId: { [orderId: number]: { budgets: PnpBudget[], fetched: boolean } };
  budgetAvailableByOrderId: { [orderId: number]: { available: boolean, fetched: boolean, fetching: boolean } };
}

export const initialState: IPnpBudgetState = {
  userBudgets: [],
  fetchingUserBudgets: false,
  fetchingForOrderId: null,
  budgetsByOrderId: {},
  budgetAvailableByOrderId: {},
};

export const pnpBudgetReducer = createReducer(
  initialState,
  on(fetchPnpBudgets, (state) => ({
    ...state,
    fetchingUserBudgets: true,
  })),
  on(fetchPnpBudgetsSuccess, (state, { budgets }) => ({
    ...state,
    fetchingUserBudgets: false,
    userBudgets: budgets,
  })),
  on(fetchPnpBudgetsFailure, (state) => ({
    ...state,
    fetchingUserBudgets: false,
  })),
  on(fetchPnpBudgetsForOrder, (state, { orderId }) => ({
    ...state,
    fetchingForOrderId: orderId,
  })),
  on(fetchPnpBudgetsForOrderSuccess, (state, { orderId, budgets }) => ({
    ...state,
    fetchingForOrderId: null,
    budgetsByOrderId: { ...state.budgetsByOrderId, [orderId]: { budgets, fetched: true } },
  })),
  on(fetchPnpBudgetsForOrderFailure, (state) => ({
    ...state,
    fetchingForOrderId: null,
  })),
  on( resetPnpBudgetsForOrder, (state, { orderId }) => ({
    ...state,
    budgetsByOrderId: { ...state.budgetsByOrderId, [orderId]: { budgets: [], fetched: false } },
  })),
  on(setPnpBudgetsForOrder, (state, { orderId, budgets }) => ({
    ...state,
    budgetsByOrderId: {
      ...state.budgetsByOrderId,
      [orderId]: { budgets: budgets || [], fetched: true },
    },
  })),
  on(fetchBudgetAvailable, (state, { orderId }) => ({
    ...state,
    budgetAvailableByOrderId: {
      ...state.budgetAvailableByOrderId,
      [orderId]: {
        available: state.budgetAvailableByOrderId[orderId]?.available ?? false,
        fetched: state.budgetAvailableByOrderId[orderId]?.fetched ?? false,
        fetching: true,
      },
    },
  })),
  on(fetchBudgetAvailableSuccess, (state, { orderId, available }) => ({
    ...state,
    budgetAvailableByOrderId: {
      ...state.budgetAvailableByOrderId,
      [orderId]: { available, fetched: true, fetching: false },
    },
  })),
  on(fetchBudgetAvailableFailure, (state, { orderId }) => ({
    ...state,
    budgetAvailableByOrderId: {
      ...state.budgetAvailableByOrderId,
      [orderId]: { available: false, fetched: true, fetching: false },
    },
  })),
  on(resetBudgetAvailable, (state, { orderId }) => {
    const rest = { ...state.budgetAvailableByOrderId };
    delete rest[orderId];
    return { ...state, budgetAvailableByOrderId: rest };
  }),
);
